export default __webpack_public_path__ + "static/default-thumb-70a564dd3b7c94df1878fb5faa3992c6.png";